
import React, { useState } from 'react';

const Scheduling = () => {
  const [workoutPreferences, setWorkoutPreferences] = useState({ duration: '', frequency: '' });

  return (
    <div className="">
      <h1>Scheduling</h1>
      <p>Specify the client's workout preferences.</p>
        <label htmlFor="duration">How long should each session be?</label>
        <input
          id="duration"
          type="text"
          value={workoutPreferences.duration}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, duration: e.target.value })}
          placeholder="Duration in minutes (e.g., 60 for 60 minutes)"
        />
        <label htmlFor="frequency">How many times per week should sessions be?</label>
        <input
          id="frequency"
          type="number"
          value={workoutPreferences.frequency}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, frequency: e.target.value })}
          placeholder="Times per week"
        />
        <label htmlFor="duration">How many sessions should be generated?</label>

        {/* In weeks or in number of sessions both available  */}
        <input
          id="sessions"
          type="number"
          value={workoutPreferences.sessions || ''}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, sessions: e.target.value })}
          placeholder="Number of sessions"
        />

        {/* Now in weeks  */}
        <label htmlFor="weeks">Or, how many weeks should the plan cover?</label>
        <input 
            id="weeks"
            type="number"
            value={workoutPreferences.weeks || ''}
            onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, weeks: e.target.value })}
            placeholder="Weeks"
        />



    </div>
  );
};

export default Scheduling;